import script from "./AppLog.vue?vue&type=script&setup=true&lang=js"
export * from "./AppLog.vue?vue&type=script&setup=true&lang=js"

import "./AppLog.vue?vue&type=style&index=0&id=6e80b9d6&scoped=true&lang=css"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e80b9d6"]])

export default __exports__